type TickerCallback = () => void | Promise<void>;

export default function createTicker(
    callback: TickerCallback,
    period = 1000,
): [start: () => void, stop: () => void] {
    let timerId: ReturnType<typeof setTimeout> | null = null;
    let running = false;

    const schedule = () => {
        timerId = setTimeout(loop, period);
    };

    const loop = async () => {
        try {
            await callback();
        } catch (err) {
            console.error('Ticker callback threw:', err);
        }
        if (running) schedule();
    };

    const start = () => {
        if (running) return;
        running = true;
        schedule();
    };

    const stop = () => {
        running = false;
        if (timerId !== null) {
            clearTimeout(timerId);
            timerId = null;
        }
    };

    return [start, stop];
}
